import AsyncStorage from '@react-native-async-storage/async-storage';
import { onboardingAPI } from '../api/onboarding';

/** Device-level key — only used for guest (unauthenticated) users. */
export const TOUR_COMPLETED_STORAGE_KEY = 'coloursense_tour_completed';

export async function markTourCompleted(userId: string | null): Promise<void> {
  if (userId) {
    // Authenticated: persist on backend only (per-user, survives device changes).
    try {
      await onboardingAPI.completeTour();
    } catch {
      // Non-fatal; wizard won't show again this session but may re-appear after relaunch.
    }
  } else {
    // Guest: fall back to device storage.
    try {
      await AsyncStorage.setItem(TOUR_COMPLETED_STORAGE_KEY, '1');
    } catch {
      // Non-fatal
    }
  }
}

/**
 * Returns true if we have a record that the user has completed/skipped the tour.
 * For authenticated users: backend is the source of truth (per-user). Device storage
 * is ignored so a new user on the same device sees the wizard.
 * For guests: only device storage.
 */
export async function getHasCompletedTour(
  isAuthenticated: boolean
): Promise<boolean> {
  if (isAuthenticated) {
    try {
      const status = await onboardingAPI.getStatus();
      return status.tour_completed === true;
    } catch {
      // On API failure, show wizard (err on side of showing)
      return false;
    }
  }
  try {
    const value = await AsyncStorage.getItem(TOUR_COMPLETED_STORAGE_KEY);
    return value === '1';
  } catch {
    return false;
  }
}
